import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import { IconType } from '@react-icons/all-files';

interface Props {
  text?: string;
  icon: IconType;
}

const AboutRow: FC<Props> = ({ text, icon: Icon }) => {
  return (
    <Box color='#868e96' display='flex' flexDirection='row' alignItems='center'>
      <Box marginRight={1}>{(props) => <Icon size={18} {...props} />}</Box>
      <Typography variant='body1'>{text || ''}</Typography>
    </Box>
  );
};

export default AboutRow;
